<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

@if (node) {
  <div class="drag-drop-tree"
       [ngClass]="{'top':node?.id==='top'}"
       [style.display]="node?.id==='top' || expandedNodes?.[node.id || node.title] ? 'block' : 'none'">
    <ng-container>
      <div
          (cdkDropListDropped)="drop($event)"
          [cdkDropListConnectedTo]="dragDropService.dropLists"
          [cdkDropListEnterPredicate]="allowDropPredicate"
          [id]="node.id"
          [cdkDropListData]="node.contents"
          [cdkDropListDisabled]="!(editMode && userService.canReorderTree())"
          cdkDropList
          class="draggable-list">

        @for (child of node.contents; track child; let i = $index) {
          <div
              cdkDrag
              [cdkDragData]="child"
              (cdkDragStarted)="onDragStarted($event)"
              [cdkDragDisabled]="child.type === MenuNodeType.FOLDER ? !userService.canReorderFolders() : !userService.canReorderPages()"
              [cdkDragPreviewClass]="'folderDragPreview'"
              (cdkDragMoved)="dragMoved($event)"
              (cdkDragReleased)="dragReleased($event)"
              class="draggable-list-item mat-tree-node"
              [ngClass]="{'folder':child.type===MenuNodeType.FOLDER}">

            @if (child.type === MenuNodeType.FOLDER && (child.menu_entry_count || editMode)) {
              <div class="parent-folder-node"
                   (mouseenter)="hoveredFolderId = child.id"
                   (mouseleave)="hoveredFolderId = null">
                @if (editMode && userService.canReorderFolders()) {
                  <div class="drag-handle" cdkDragHandle>☰</div>
                }
                <button class="folder-toggle"
                        (click)="onNodeToggled(child)">
                  <i [ngClass]="expandedNodes[child.id || child.title] ? 'chevron-up' : 'chevron-down'"></i>
                  @if (editingEntityId !== child.id) {
                    <span
                        [class.entity-name-saving]="savingRenameIds.has(child.id)"
                        (click)="onFolderNameClick($event, child)">
                  {{child.folder.attributes.name}}
                </span>
                  }
                </button>

                <!-- Deliberately OUTSIDE button.folder-toggle: the ✓/⊘ rely on being flex
                     children of .parent-folder-node for align-self to mean anything, and the
                     editor's host is display:contents so they still are. -->
                @if (editingEntityId === child.id) {
                  <entity-name-editor
                      [name]="child.folder.attributes.name"
                      (save)="saveRename(child, $event)"
                      (cancel)="cancelRename()">
                  </entity-name-editor>
                }

                @if (editMode && userService.canOpenFolderContextMenu(child.total_page_count > 0) && hoveredFolderId === child.id && editingEntityId !== child.id) {
                  <button class="folder-context-trigger"
                          (click)="openContextMenu($event, child)">&#x22EF;&nbsp;
                  </button>
                }
              </div>

              <dragdrop-tree [node]="child" [expandedNodes]="expandedNodes">
              </dragdrop-tree>
            }

            @if (child.type === MenuNodeType.MENU) {
              <div class="menu-node row"
                   [style.display]="child.visible ? 'flex' : 'none'"
                   (mouseenter)="hoveredPageId = child.session_state.id"
                   (mouseleave)="hoveredPageId = null">
                @if (editMode && userService.canReorderPages()) {
                  <div class="drag-handle" cdkDragHandle>☰</div>
                }
                <!-- Pages rename from the ⋯ menu, not by clicking the name like a folder does:
                     the name is a routerLink, so a click has to keep opening the page. -->
                @if (editingEntityId === child.session_state.id) {
                  <entity-name-editor
                      [name]="child.session_state.attributes.name"
                      (save)="saveRename(child, $event)"
                      (cancel)="cancelRename()">
                  </entity-name-editor>
                }
                @if (editingEntityId !== child.session_state.id) {
                  <a [routerLink]="!isDragging ? 'view/page_view/' + child.session_state.id : null"
                     [class.entity-name-saving]="savingRenameIds.has(child.session_state.id)"
                     (click)="!isDragging && closeSidenav()">{{child.session_state.attributes.name}}</a>
                  @if (editMode && userService.canRenamePage() && hoveredPageId === child.session_state.id) {
                    <button class="page-context-trigger"
                            (click)="openPageContextMenu($event, child)">&#x22EF;&nbsp;
                    </button>
                  }
                }
              </div>
            }
          </div>
        }
        @if (editMode && node?.id !== 'top' && !hasVisibleContent()) {
          <div class="empty-folder-placeholder">
            {{node.total_page_count > 0 ? 'No pages available' : 'Empty'}}
          </div>
        }
      </div>
    </ng-container>
  </div>
}
